class PaymentModel { 
    static json = {
        "sale_id": "564bae81-56e1-4a3b-8099-5ab3f96b0cca",
        "customer_id": "56f9f322-b9df-4c4b-aa7f-6819dbfdd6b2",
        "backoffice_id": null,
        "amount": 7.32,
        "payment_type": 1,
        "backoffice_key": 0,
        "transaction_id": null,
        "pos_transaction_id": "74",
        "auth_code": null,
        "last4": "6456",
        "success": true,
        "message": "Pax credit card payment accepted",
        "payment_status": 1,
        "card_type": 4,
        "cash_paid": 0.0,
        "cash_change": 0.0,
        "is_active": true,
        "is_test_mode": true,
        "signature_image_url": "https://s3-us-west-2.amazonaws.com/dev-paylani-images/signature564bae81-56e1-4a3b-8099-5ab3f96b0cca-637975880883992956.png",
        "pos_transaction_data": "{\"AuthCode\":\"000000\",\"ApprovedAmount\":\"732\",\"AvsResponse\":\"\",\"BogusAccountNum\":\"6456\",\"CardType\":\"VISA\",\"CvResponse\":\"\",\"HostCode\":\"88888888\",\"HostResponse\":\"0\",\"Message\":\"DEMO APPROVED\",\"RefNum\":\"74\",\"RawResponse\":\"\",\"RemainingBalance\":\"\",\"ExtraBalance\":\"\",\"RequestedAmount\":\"732\",\"ResultCode\":\"000000\",\"ResultTxt\":\"OK\",\"Timestamp\":\"20220831201438\",\"SigFileName\":\"\",\"SignData\":\"\",\"TransactionIntegrityClass\":\"\",\"ExtData\":\"<BatchNum>1</BatchNum><AmountDue>0</AmountDue><TipAmount>0</TipAmount><CashBackAmount>0</CashBackAmount><MerchantFee>0</MerchantFee><TaxAmount>0</TaxAmount><PLEntryMode>2</PLEntryMode><ExpDate>1026</ExpDate><PLNameOnCard>CARDHOLDER/VISA</PLNameOnCard><PLCardPresent>0</PLCardPresent><ECRRefNum>1661991278044</ECRRefNum><EDCTYPE>CREDIT</EDCTYPE><CARDBIN>440066</CARDBIN><PROGRAMTYPE>0</PROGRAMTYPE><SN>1760014462</SN><GlobalUID>1760014462202208312014382959</GlobalUID><TC>064D7D600D49DB1B</TC><TVR>0000000000</TVR><AID>A0000000031010</AID><TSI>0000</TSI><ATC>018A</ATC><APPLAB>VISA CREDIT</APPLAB><IAD>06011203A00000</IAD><CVM>7</CVM><userLanguageStatus>1</userLanguageStatus>\",\"GiftCardType\":\"\",\"TransactionRemainingAmount\":\"\",\"DebitAccountType\":\"\",\"HostDetailedMessage\":\"\",\"GatewayTransactionID\":\"\",\"RetrievalReferenceNumber\":\"\",\"MaskedPAN\":\"\",\"Track1Data\":\"\",\"Track2Data\":\"\",\"Track3Data\":\"\",\"EDCType\":\"\",\"PaymentService2000\":\"\",\"AuthorizationResponse\":\"\",\"IssuerResponseCode\":\"\",\"ECRTransID\":\"\",\"ApprovedTipAmount\":\"\",\"ApprovedCashBackAmount\":\"\",\"ApprovedMerchantFee\":\"\",\"ApprovedTaxAmount\":\"\",\"PaymentAccountReferenceID\":\"\",\"PayloadData\":\"\",\"AddlRspData\":{\"ACI\":\"\",\"TransID\":\"\",\"CardLevelResult\":\"\",\"SourceReasonCode\":\"\",\"BankNetData\":\"\",\"POSEntryModeChg\":\"\",\"TranEditErrCode\":\"\",\"DiscProcCode\":\"\",\"DiscPOSEntry\":\"\",\"DiscRespCode\":\"\",\"POSData\":\"\",\"DiscTransQualifier\":\"\",\"DiscNRID\":\"\",\"TrnmsnDateTime\":\"\",\"OrigSTAN\":\"\",\"CVVErrorCode\":\"\",\"XCodeResp\":\"\",\"AthNtwkID\":\"\",\"TermEntryCapablt\":\"\",\"POSEntryMode\":\"\",\"ServCode\":\"\",\"SpendQInd\":\"\",\"WltID\":\"\",\"LocalDateTime\":\"\",\"EMVTags\":\"\"},\"CardInfo\":{\"CardBin\":\"440066\",\"NewCardBin\":\"\",\"ProgramType\":\"0\"},\"PaymentTransInfo\":{\"OrigTip\":\"\",\"EdcType\":\"CREDIT\",\"PrintLine1\":\"\",\"PrintLine2\":\"\",\"PrintLine3\":\"\",\"PrintLine4\":\"\",\"PrintLine5\":\"\",\"EwicBenefitExpd\":\"\",\"EwicBalance\":\"\",\"EwicDetail\":\"\",\"ReverseAmount\":\"\",\"ReversalStatus\":\"\",\"TokenSerialNum\":\"\",\"DiscountAmount\":\"\",\"ChargedAmount\":\"\",\"SignatureStatus\":\"\",\"Fps\":\"\",\"FpsSignature\":\"\",\"FpsReceipt\":\"\",\"Token\":\"\",\"HRef\":\"\",\"SN\":\"1760014462\",\"SettlementDate\":\"\",\"HostEchoData\":\"\",\"PinStatusNum\":\"\",\"ValidationCode\":\"\",\"UserLanguageStatus\":\"\",\"GlobalUid\":\"1760014462202208312014382959\"},\"PaymentEmvTag\":{\"Ac\":\"\",\"Aip\":\"\",\"Avn\":\"\",\"IssuerAuthData\":\"\",\"Cdol2\":\"\",\"Hred\":\"\",\"TacDefault\":\"\",\"TacDenial\":\"\",\"TacOnline\":\"\",\"IacDefault\":\"\",\"IacDenial\":\"\",\"IacOnline\":\"\",\"Auc\":\"\",\"PanSeqNum\":\"\",\"Tc\":\"064D7D600D49DB1B\",\"Tvr\":\"0000000000\",\"Aid\":\"A0000000031010\",\"Tsi\":\"0000\",\"Atc\":\"018A\",\"AppLabel\":\"VISA CREDIT\",\"AppPreferName\":\"\",\"Iad\":\"06011203A00000\",\"Arc\":\"\",\"Cid\":\"\",\"Cvm\":\"7\",\"Arqc\":\"\"}}",
        "status": 0,
        "id": "da954e41-a2fe-4be9-b016-64c272450f48",
        "created": "2022-09-01T00:14:44.64",
        "modified": "2022-09-01T00:14:48.463"
    };

    constructor(json) {
        if (!json) json = {};
        
        this.id = json.id || "";
        this.saleId = json.sale_id || "";
        this.amount = json.amount || 0;

        this.success = json.success || false;
        this.message = json.message || "";

        this.customerId = json.customer_id || null;
        this.backofficeId = json.backoffice_id || null;
        this.transactionId = json.transaction_id || null;
        this.authCode = json.auth_code || "";
        this.posTransactionId = json.pos_transaction_id || "";
        this.last4 = json.last4 || "";

        this.paymentType = json.payment_type || 0;
        this.paymentTypeName = json.payment_type_name || "Unknown Type";
        
        this.paymentStatus = json.payment_status || 0;
        this.paymentStatusName = json.payment_status_name || "Unknown Status";
        
        this.cardType = json.card_type || 0;
        this.cardTypeName = json.card_type_name || "";
        
        this.cashPaid = json.cash_paid || 0.0;
        this.cashChange = json.cash_change || 0.0;
        this.isActive = json.is_active || false;
        this.isTestMode = json.is_test_mode || false;
        this.signatureImageUrl = json.signature_image_url || "";
        this.posTransactionData = json.pos_transaction_data ? JSON.parse(json.pos_transaction_data) : null;
        this.status = json.status || 0;
        this.statusName = json.status_name || "";
        
        this.created = json.created ? new Date(json.created) : null;
        this.modified = json.modified ? new Date(json.modified) : null;
    }

    static fromJsonArray(jsonArray) { 
        if (!jsonArray) return [];
        return jsonArray.map(json => new PaymentModel(json));
    }
    
    static createPaymentJson(creditCard, ach, amount, paymentMethodType, customerId, customer) {
        const cc = !!creditCard ? {
            name: creditCard?.name,
            number: creditCard?.number,
            expire_date: creditCard?.expiration_month + creditCard?.expiration_year,
            cvv: creditCard?.cvv,
            billing_zip: null,
            customer: customer || null
        } : null;

        const ac = !!ach ? {
            name: ach?.name,
            routing_number: ach?.routing_number,
            account_number: ach?.account_number,
            account_type: ach?.account_type,
            account_holder_type: ach?.account_holder_type,
            sec_code: ach?.sec_code
        } : null;

        return {
            transaction_id: null,
            amount: amount,
            credit_card: cc || undefined,
            ach: ac || undefined,
            cash: null,
            payment_id: null,
            customer_id: customerId || (customer?.id || null),
            payment_type: parseInt(paymentMethodType),
        };
    }
}

export default PaymentModel;
